import { Injectable } from '@angular/core';

import { ApiService }                     from '../api/api.service';
import { SessionService }                 from '../sessions/session.service';
import { TireconnectWidgetSettingsModel } from './typings/tireconnect.widget-settings';
import { VehicleModel }                   from '../vehicles/models/vehicle';

@Injectable({
  providedIn: 'root'
})
export class TireconnectService {
  dataSelector = '#tcwlw_raw_quote';
  storageKey   = 'tireconnectWidgetData';

  constructor (
    private apiService    : ApiService,
    private sessionService: SessionService
  ) {}

  getPortalUrl ( vehicle : VehicleModel, id : string, type : 'invoice' | 'event' ) : Promise<string> {
    return this.getWidgetSettings()
    .then(( settings : TireconnectWidgetSettingsModel ) => {
      const data : any = {
        api           : settings.tireconnect_api_key,
        reference_id  : id,
        reference_type: type
      };

      if (vehicle.id) {
        data.location_id = settings.tireconnect_location_id;

        if (vehicle.vin) {
          data.vin = vehicle.vin;
        }
        else {
          data.state   = vehicle.plate_state;
          data.license = vehicle.plate_number;
        }
      }

      this.sessionService.setKey(this.storageKey, data);

      return '/tireconnect.html';
    });
  }

  getWidgetSettings () : Promise<TireconnectWidgetSettingsModel> {
    return this.apiService.get('/tireconnect/widget_settings');
  }
}
